import { useStorePages } from '~/stores/abstract/pages';
import { useStoreCataloguePage } from '~/stores/strapi/cataloguePage';
import { parseCategory } from '~/stores/strapi/categoryPage';
import { useStoreFortuneWheel } from '~/stores/strapi/fortuneWheel';
import { useStoreInfoPages } from '~/stores/strapi/infoPages';
import { parseProvider } from '~/stores/strapi/providers';
import { parseSlotTheme } from '~/stores/strapi/slotThemes';
import { EPageType } from '~/types/pageType';
import initPage from '~/utils/pages';
import type { NuxtApp } from '#app';

export const fetchPage = async (
  context: NuxtApp
): Promise<{ type: EPageType | null; data: any } | null> => {
  let payloadMock;
  let _pageId = (context._route.params.pageId as string) || 'allGames';

  if (_pageId === 'allGames' && context._route.path?.startsWith('/slot-themes')) {
    _pageId = 'slot-themes';
  }

  if (useStoreInfoPages().pageType && useStoreInfoPages().pageData?.pageId === _pageId) {
    return { type: useStoreInfoPages().pageType, data: useStoreInfoPages().pageData };
  }

  const payload = context.payload.data[`pageTypeData_${_pageId}`];

  if (payload) {
    payloadMock = payload;
  }

  const { type, data } = await initPage({ pageId: _pageId, payload: payloadMock });

  const actualType = type || payloadMock?.type || EPageType.none;
  if (actualType === EPageType.none) {
    useStoreInfoPages().SET_PAGE_TYPE(actualType);
    return null;
  }

  // @TODO: refactro this with games
  if (
    [EPageType.provider, EPageType.category, EPageType.slotTheme].includes(
      actualType || EPageType.none
    )
  ) {
    await useStorePages().loadCatalogueData(true);

    if (actualType === EPageType.provider) {
      useStoreCataloguePage().setProvider(_pageId);
    } else if (actualType === EPageType.category || actualType === EPageType.slotTheme) {
      useStoreCataloguePage().setCollection(_pageId);
    }
  }
  if (
    actualType === EPageType.info &&
    _pageId === 'wheel-of-fortune' &&
    !useStoreFortuneWheel().isLoaded
  ) {
    await useStoreFortuneWheel().loadFortuneWheel();
  }

  useStoreInfoPages().SET_PAGE_DATA({
    ...(() => {
      if (!_pageId) {
        return null;
      }
      switch (actualType) {
        case EPageType.info:
          return data;
        case EPageType.provider:
          return parseProvider(data);
        case EPageType.category:
          return parseCategory(data);
        case EPageType.slotTheme:
          return data.attributes ? parseSlotTheme(data) : data;
        default:
          return null;
      }
    })(),
    pageId: _pageId,
  });

  useStoreInfoPages().SET_PAGE_TYPE(actualType);

  if (context._route.path?.includes('/not-found')) {
    useStoreInfoPages().SET_PAGE_TYPE(EPageType.info);
  }

  return {
    type,
    data: (() => {
      if (!_pageId) {
        return null;
      }
      switch (actualType) {
        case EPageType.info:
          return data;
        case EPageType.provider:
          return parseProvider(data);
        case EPageType.category:
          return parseCategory(data);
        case EPageType.slotTheme:
          return data.attributes ? parseSlotTheme(data) : data;
        default:
          return data;
      }
    })(),
  };
};
